import { Controller, useFormContext } from 'react-hook-form';
import { Modal, Button, Select } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { MultiAutocomplete } from 'ui/multiAutocomplete/MultiAutocomplete';
import { useRenderMultiAutocompleteOption } from 'ui/multiAutocomplete/hooks/useRenderMultiAutocompleteOption';
import { useAppSelectOptions } from 'hooks/useAppSelectOptions/useAppSelectOptions';
import { Form } from 'ui/form/Form';

import { AddTerminalsDisplayFormBody, AddTerminalsDisplayProps } from './AddTerminalsDisplay.types';

const BUTTON_WIDTH = 200;

export const AddTerminalsDisplay = ({
  onModalOpen,
  onModalClose,
  isLoading,
  onSubmit,
  isModalOpen,
  isLoadingTerminals,
  terminals,
  selectedServerId,
  setSelectedServerId,
  servers,
}: AddTerminalsDisplayProps) => {
  const { formatMessage } = useLocale();
  const { renderMultiAutocompleteOption } = useRenderMultiAutocompleteOption();

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext<AddTerminalsDisplayFormBody>();

  const isTkdNotSelected = !watch('idTkds')?.length;

  const getOptions = () => {
    return terminals.map((terminal) => ({
      label: terminal.nazwa,
      value: terminal.id,
      number: terminal.numerLogicznyKontrolera,
    }));
  };

  const { serverOptions } = useAppSelectOptions({ servers });

  return (
    <>
      <Button style={{ width: BUTTON_WIDTH }} onClick={onModalOpen} variant="contained">
        {formatMessage({ id: AppMessages['definitions.display.addReader'] })}
      </Button>

      <Modal
        header={formatMessage({ id: AppMessages['definitions.display.add.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        type="form"
        onSubmit={handleSubmit(onSubmit)}
        submitButtonDisabled={isTkdNotSelected || isLoading || !!Object.keys(errors).length}
      >
        <Form.Grid>
          <Select
            value={selectedServerId}
            required
            onChange={(e) => {
              setValue('idTkds', []);
              setSelectedServerId(e.target.value as string);
            }}
            label={formatMessage({ id: AppMessages['groups.addGroup.permissions.field.serverName.label'] })}
            withHelperText
            options={serverOptions}
          />

          <Controller
            name="idTkds"
            control={control}
            render={({ field }) => (
              <MultiAutocomplete
                {...field}
                required
                withLimitedTags
                stopRotatePopupIndicator
                inputSize="big"
                limitTags={1}
                onChange={(_, option) => (option ? field.onChange(option) : field.onChange(null))}
                options={getOptions()}
                loading={isLoadingTerminals}
                loadingText={formatMessage({ id: AppMessages['common.loading'] })}
                label={formatMessage({ id: AppMessages['definitions.display.add.terminal.label'] })}
                noOptionsText={formatMessage({ id: AppMessages['common.notFound'] })}
                placeholder={formatMessage({ id: AppMessages['definitions.display.add.terminal.placeholder'] })}
                renderOption={renderMultiAutocompleteOption}
              />
            )}
          />
        </Form.Grid>
      </Modal>
    </>
  );
};
